<template>
    <button
        v-on:click="show()"
        class="reset padding-left-xs padding-right-xs"
        aria-controls="notifications-bar"
        :aria-expanded="[expanded ? 'true' : 'false']"
        
    >
        <svg aria-label="Notifications Icon" role="img" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">
            <path fill="currentColor" d="M14.4,7.8C13.6,7.1,13,6.7,13,6V5c0-2.8-2.2-5-5-5S3,2.2,3,5v1c0,0.7-0.6,1.1-1.4,1.8C0.8,8.4,0,9,0,10 c0,2.8,6.1,3,8,3s8-0.2,8-3C16,9,15.2,8.4,14.4,7.8z"></path>
            <path data-color="color-2" fill="currentColor" d="M10.9,13.9C9.8,14,8.9,14,8,14s-1.8,0-2.9-0.1C5.5,15.1,6.6,16,8,16S10.5,15.1,10.9,13.9z"></path>
        </svg>
        <span class="sr-only">{{ label }}</span>
    </button>
</template>
<script>
import { actions, getters, setters } from './store';

export default {
    props: {
        label: {
            type: String,
            default: 'Notifications',
        },
    },
    mounted: () => {
        actions.init();
    },
    computed: {
        expanded: () => {
            return getters.show();
        },
    },
    methods: {
        show: function () {
            setters.show(true);
        },
    },
};
</script>
